import {
  ContentIndexTypeEnum,
  ContentTypeEnum,
  IStaticContext,
  IStaticData,
  ITableDataIndexType,
  TitleLevelEnum,
} from "@/static/dataType";

const data: Array<IStaticData> = [
  {
    title: {
      text: "APIキー認証方式について",
    },
    content: [
      {
        text: "当サイトでは、2つの認証方式（APIキー / OAuth2.0）のいずれかを選んでアプリケーションを作成することができます。",
        styleObject: { fontWeight: 500 },
      },
      {
        text: "APIキー認証とOAuth2.0認証には以下のような違いがあります。まずは最小限の実装でSafie APIおよびSafie SDK(JavaScript)を試してみたいという方はAPIキー認証を選ぶのがお勧めです。",
      },
      {
        type: ContentTypeEnum.table,
        table: {
          pcTable: {
            column: [
              {
                prop: "column1",
                label: "",
                width: "194",
              },
              {
                prop: "column2",
                label: "APIキー認証",
              },
              {
                prop: "column3",
                label: "OAuth2.0認証",
              },
            ],
            data: [
              {
                column1: [
                  {
                    text: "想定される用途例",
                  },
                ],
                column2: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "録画した映像データから定期的に静止画を取得できるようにしたい",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "映像上で何かを検知した時の動画を取得できるようにしたい",
                  },
                ],
                column3: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "独自のアプリケーションを開発して自社SaaSへ組み込みたい",
                  },
                ],
              },
              {
                column1: [
                  {
                    text: "こんな方におすすめ",
                  },
                ],
                column2: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "最小限の実装でAPIおよびSDK（JavaScript）を試してみたい方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "自社SaaSを持たない方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "連携デバイス管理をセーフィーにまかせたい方",
                  },
                ],
                column3: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "より強固なセキュリティで運用したい方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "Safieと自社SaaSを連携させたい方",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "連携デバイス管理を自社システムで行いたい方",
                  },
                ],
              },
            ],
          },
          spTable: [
            {
              column: [
                {
                  prop: "column1",
                  label: "",
                  width: "100",
                },
                {
                  prop: "column2",
                  label: "APIキー認証",
                },
              ],
              data: [
                {
                  column1: [
                    {
                      text: "想定される用途例",
                    },
                  ],
                  column2: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "録画した映像データから定期的に静止画を取得できるようにしたい",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "映像上で何かを検知した時の動画を取得できるようにしたい",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "こんな方におすすめ",
                    },
                  ],
                  column2: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "最小限の実装でAPIおよびSDK（JavaScript）を試してみたい方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "自社SaaSを持たない方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "連携デバイス管理をセーフィーにまかせたい方",
                    },
                  ],
                },
              ],
            },
            {
              column: [
                {
                  prop: "column1",
                  label: "",
                  width: "100",
                },
                {
                  prop: "column3",
                  label: "OAuth2.0認証",
                },
              ],
              data: [
                {
                  column1: [
                    {
                      text: "想定される用途例",
                    },
                  ],
                  column3: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "独自のアプリケーションを開発して自社SaaSへ組み込みたい",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "こんな方におすすめ",
                    },
                  ],
                  column3: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "より強固なセキュリティで運用したい方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "Safieと自社SaaSを連携させたい方",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "連携デバイス管理を自社システムで行いたい方",
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    ],
  },

  {
    title: {
      text: "アプリケーションの新規作成",
    },
    children: [
      {
        title: {
          text: "1. 新規作成を開始",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "アプリケーション一覧画面から、APIキー認証アプリケーション「アプリケーション新規作成」ボタンをクリック（タップ）してください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/applications.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/applications-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "2. アプリケーション名称を入力",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "アプリケーションの名称を入力してください。",
            styleObject: { marginLeft: "24px" },
          },
        ],
      },
      {
        title: {
          text: "3.プランを選択",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "トライアルプランとプロダクトプランをご用意しています。",
            styleObject: { marginLeft: "24px" },
          },
          {
            text: "プロダクトプランは、基本は有料かつ商用利用が可能なプランです。トライアルプランは、無料かつオプションの申し込み不要でご利用いただけるお試し用のプランです。",
            styleObject: { marginTop: "0px", marginLeft: "24px" },
          },
          {
            text: "それぞれのプランの機能制約については<a href='/terms-of-api' class='is-static-link' target='_blank'>こちら</a>をご確認ください。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/api-key1.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/api-key1-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "4. 公開状況を選択",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "公開状況を選択してください。すぐにデバイスとアプリケーションとの紐付けを行う場合は「公開」を選択してください。",
            styleObject: { marginLeft: "24px" },
          },
        ],
      },
      {
        title: {
          text: "5. 利用したいAPIおよびSDK(JavaScript)にチェック",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "ご利用になりたいAPIおよびSDK(JavaScript)にチェックを付けてください。APIおよびSDK(JavaScript)ごとに「サービス利用者の許可が必要になる権限」が定められていますのでご確認ください。各機能の種類はリファレンスをご確認ください。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            text: "<a href='/reference/api' class='is-static-link' target='_blank'>APIリファレンス</a>",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            text: "<a href='/reference/sdk' class='is-static-link' target='_blank'>SDK(JavaScript)リファレンス</a>",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            text: "なお、1つのアプリケーションにSafie API「Live v2」とSDK(JavaScript)「Player」を同時に設定をすることはできません。どちらを利用するか指定してください。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/api-key2.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/api-key2-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "6. 利用したいAPIおよびSDK(JavaScript)に合わせて必要なカメラオプションを選択",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "画像取得API（月間リクエスト数）など、利用したいAPIおよびSDK(JavaScript)によってはカメラオプションを複数の中から選択いただく必要があります。オプションに関してはこちらをご確認ください。トライアルプランの場合はこのステップは必要ありません。",
            styleObject: { marginLeft: "24px" },
            type: ContentTypeEnum.link,
          },
          {
            text: "<a href='/terms-of-api' class='is-static-link' target='_blank'>APIのオプション名一覧</a>",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            text: "<a href='/terms-of-api/sdk' class='is-static-link' target='_blank'>SDK(JavaScript)のオプション名一覧</a>",
            styleObject: { marginLeft: "24px" },
            indexType: ContentIndexTypeEnum.circle,
            type: ContentTypeEnum.link,
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/api-key3.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/api-key3-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
      {
        title: {
          text: "7. 内容を確認して新規作成",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "入力内容を確認の上、「この内容で新規作成」をクリック（タップ）してください。続いてAPIキーの取得へと進んでください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/api-key4.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/api-key4-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
    ],
  },
  {
    title: {
      text: "APIキーの取得",
    },
    content: [
      {
        text: "アプリケーション作成後、「APIキー新規発行」をクリック（タップ）してください。APIキー名を入力して「発行」をクリック（タップ）すればAPIキーが発行されます。",
      },
      {
        text: "2個目のAPIキーを発行したい場合は、上記と同様の作業を行ってください。1つのアプリケーションにつき発行できるAPIキーは最大2個です。",
      },
      {
        type: ContentTypeEnum.image,
        styleObject: { marginLeft: "24px" },
        image: {
          pcUrl: require("./images/api-key-get.png"),
          pcMaxWidth: "600px",
          pcWidth: "100%",
          spUrl: require("./images/api-key-get-sp.png"),
          spWidth: "319px",
          spMaxWidth: "319px",
          title: "APIキー管理",
        },
      },
    ],
  },
  {
    title: {
      text: "APIキーとデバイスの紐付け",
    },
    children: [
      {
        content: [
          {
            text: "APIキー認証を使ったアプリケーションをユーザーに利用してもらうには、以下の手順によるデバイス（カメラ）との紐付けが必要です。",
          },
        ],
      },
      {
        title: {
          text: "1. アプリケーションコードを確認",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "アプリケーション一覧画面で、アプリケーションコードを確認してください。そのアプリケーションコードをユーザー（デバイスオーナー）に伝えて、下記2.の作業を行ってもらってください。",
            styleObject: { marginLeft: "24px" },
          },
        ],
      },
      {
        title: {
          text: "2. Safie Viewer上でアプリケーションの追加申請",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "Safie Viewerにログインして、「ユーザー設定」ページの「Developers連携」へと進み、「アプリケーションを追加」をクリック（タップ）してください。アプリケーションコードを入力の上、紐付けるデバイスを選択して、アプリケーションの追加申請を行ってください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/viewer-developer.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              spUrl: require("./images/viewer-developer-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
          {
            type: ContentTypeEnum["tip-link"],
            styleObject: { marginLeft: "24px" },
            text: "他のユーザーのデバイスとAPIキーを紐付けるためには、事前審査が必要となります。詳しくは<a href='/faq?path=0-0-2' class='is-static-link' target='_blank'>こちら</a>をご確認ください。",
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/api-key-viewer.png"),
              pcMaxWidth: "354px",
              pcWidth: "100%",
              spUrl: require("./images/api-key-viewer-sp.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
              title: "Safie Viewerのアプリケーション追加申請画面",
            },
          },
        ],
      },
      {
        title: {
          text: "3. 申請を承認",
          level: TitleLevelEnum.second,
        },
        content: [
          {
            text: "ユーザーからの申請が行われると、連携デバイス管理ページ上に申請内容が表示されます。問題なければ、承認状況の項目を「承認」に変更して保存してください。",
            styleObject: { marginLeft: "24px" },
          },
          {
            type: ContentTypeEnum.image,
            styleObject: { marginLeft: "24px" },
            image: {
              pcUrl: require("./images/api-key5.png"),
              pcMaxWidth: "600px",
              pcWidth: "100%",
              // TODO: no sp image ,now use pc image
              spUrl: require("./images/api-key5.png"),
              spWidth: "319px",
              spMaxWidth: "319px",
            },
          },
        ],
      },
    ],
  },
  {
    title: {
      text: "アクセス許可設定について",
    },
    content: [
      {
        text: "作成されたアプリケーションは、初期状態ではすべてのIPアドレスからAPIおよびSDK(JavaScript)を利用できる状態になっています。指定したIPアドレスからのみアクセスを許可するようにする場合は、「アクセス許可」よりソースIPアドレスを新規登録してください。",
      },
      {
        text: "SDK(JavaScript)をご利用の場合、アクセス許可設定を行うことを推奨しております。",
        type: ContentTypeEnum["tip-link"],
      },
      {
        type: ContentTypeEnum.image,
        styleObject: { marginLeft: "24px" },
        image: {
          pcUrl: require("./images/api-key6.png"),
          pcMaxWidth: "600px",
          pcWidth: "100%",
          spUrl: require("./images/api-key6-sp.png"),
          spWidth: "319px",
          spMaxWidth: "319px",
        },
      },
    ],
  },
];
const context: IStaticContext = {
  headerTitle: "APIキー認証",
  headerIcon: require("./images/header-icon.svg"),
  data,
};
export default context;
